import { WsReactBaseService } from 'ws-react-base-components';
import { BaseActions } from 'ws-voice-infinity-global-module/lib/actions';
import { globalConfig } from 'ws-voice-infinity-global-module/lib/configs';
import { SORT_DIRECTION } from 'ws-voice-infinity-global-module/lib/enums';
import { CollectionDTOInterface, ISimpleValue } from 'ws-voice-infinity-global-module/lib/interfaces';
import { TypeService } from 'ws-voice-infinity-global-module/lib/services';
import { Execution, ExecutionDTO, ExecutionType } from '../../Global/models/execution';
import { ComplaintCreateParamsInterface } from '../interfaces/complaintCreateParamsInterface';
import { ComplaintUpdateParamsInterface } from '../interfaces/complaintUpdateParamsInterface';
import { IComplaintsListParams } from '../interfaces/IComplaintsListParams';
import { ComplaintInternal, ComplaintInternalDTO, ComplaintInternalType } from '../models/complaintInternal';
import { ComplaintList, ComplaintListDTO, ComplaintListType } from '../models/complaintList';
import { ComplaintStatistic, ComplaintStatisticDTO, ComplaintStatisticType } from '../models/complaintStatistic';

export class ComplaintInternalActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/meeting-service/internal/meetings/`;
    static ENTITY_CLASS = 'ComplaintInternal';
    static ENTITY_LIST_CLASS = 'ComplaintList';
    static ENTITY_EXECUTION = 'Execution';
    static ENTITY_STATISTIC = 'ComplaintStatistic';
}

/**
 * Создание обращения
 */
export function create(params: ComplaintCreateParamsInterface): Promise<ComplaintInternal | null> {
    return ComplaintInternalActions.API_RESOURCE('create', WsReactBaseService.POST_METHOD, params)
        .then((res: ComplaintInternalDTO) => TypeService.checkElement<ComplaintInternal>(ComplaintInternalType, ComplaintInternal, ComplaintInternalActions.ENTITY_CLASS, res));
}

/**
 * Обновление обращения
 */
export function update(params: ComplaintUpdateParamsInterface): Promise<ComplaintInternal | null> {
    return ComplaintInternalActions.API_RESOURCE(`${params.id}/update`, WsReactBaseService.POST_METHOD, params)
        .then((res: ComplaintInternalDTO) => TypeService.checkElement<ComplaintInternal>(ComplaintInternalType, ComplaintInternal, ComplaintInternalActions.ENTITY_CLASS, res));
}

/**
 * Получить обращение
 */
export function getItem(id: string): Promise<ComplaintInternal | null> {
    return ComplaintInternalActions.API_RESOURCE(id, WsReactBaseService.GET_METHOD)
        .then((res: ComplaintInternalDTO) => TypeService.checkElement<ComplaintInternal>(ComplaintInternalType, ComplaintInternal, ComplaintInternalActions.ENTITY_CLASS, res));
}

/**
 * Удалить обращение
 */
export function deleteItem(id: string): Promise<any> {
    return ComplaintInternalActions.API_RESOURCE(`${id}/delete`, WsReactBaseService.POST_METHOD);
}

/**
 * Получить список обращений пользователя
 * @param params
 */
export function listByCurrentUser(params: IComplaintsListParams = {}): Promise<CollectionDTOInterface<ComplaintList>> {
    let bodyParams: IComplaintsListParams = {
        pageNo: 0,
        pageSize: globalConfig.pageSize,
        ...params,
    };

    let queryParams = {
        pageNo: bodyParams.pageNo,
        pageSize: bodyParams.pageSize,
    };

    delete bodyParams.pageNo;
    delete bodyParams.pageSize;

    return ComplaintInternalActions.API_RESOURCE('list/by-current-user', WsReactBaseService.POST_METHOD, bodyParams, { params: queryParams })
        .then(res => ({
            items: res.items.map((complaintListDto: ComplaintListDTO) =>
                TypeService.checkElement<ComplaintList>(ComplaintListType, ComplaintList, ComplaintInternalActions.ENTITY_LIST_CLASS, complaintListDto),
            ),
            totalCount: res.totalCount,
        }));
}

/**
 * Получить список исполнений
 * @param idComplaint
 */
export function executionList(idComplaint: string): Promise<CollectionDTOInterface<Execution>> {
    return ComplaintInternalActions.API_RESOURCE(`${idComplaint}/executions/list`, WsReactBaseService.GET_METHOD, {
        orderByDirection: SORT_DIRECTION.DESC,
    })
        .then(res => ({
            items: res.items.map((executionDto: ExecutionDTO) =>
                TypeService.checkElement<Execution>(ExecutionType, Execution, ComplaintInternalActions.ENTITY_EXECUTION, executionDto),
            )
                .filter((el: Execution | null) => !!el),
            totalCount: res.totalCount,
        }));
}

/**
 * Получить статистику по обращениям
 */
export function complaintStatistic(): Promise<ComplaintStatistic[]> {
    return ComplaintInternalActions.API_RESOURCE('by-current-user/statistics/by-public-status', WsReactBaseService.GET_METHOD)
        .then(res => res.map((complaintStatisticDto: ComplaintStatisticDTO) => TypeService.checkElement<ComplaintStatistic>(ComplaintStatisticType, ComplaintStatistic, ComplaintInternalActions.ENTITY_STATISTIC, complaintStatisticDto),
        )
            .filter((el: ComplaintStatistic | null) => !!el));
}

/**
 * Пометить записи хода исполнения как прочитаные
 */
export function batchRead(idComplaint: string, executionsIds: string[]): Promise<any> {
    const params: ISimpleValue<string[]> = { value: executionsIds };

    return ComplaintInternalActions.API_RESOURCE(`${idComplaint}/executions/batch-read`, WsReactBaseService.POST_METHOD, params);
}

/**
 * Изменить значение флага publicRequest в обращении (скрыть / опубликовать)
 * @param complaintId
 */
export function toggleHide(complaintId: string): Promise<ISimpleValue<boolean>> {
    return ComplaintInternalActions.API_RESOURCE(`${complaintId}/toggle-hide`, WsReactBaseService.POST_METHOD);
}

/**
 * Скрыть/Раскрыть запись хода исполнения
 */
export function toggleExecutionHide(complaintId: string, executionId: string): Promise<any> {
    return ComplaintInternalActions.API_RESOURCE(`${complaintId}/executions/${executionId}/toggle-hide`, WsReactBaseService.POST_METHOD);
}
